module.exports = __webpack_public_path__ + "static/media/loc1_img35.2320f5db.jpg";